"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.edit = exports.create = void 0;
const ActionTypes = require("../../actionTypes/project/lightAdmin");
const Actions = require("../../actions/project/lightAdmin");
const MemberActions = require("../../actions/project/members");
const operators_1 = require("rxjs/operators");
const rxjs_1 = require("rxjs");
const errorHandling_1 = require("../../utils/errorHandling");
const lightAdmin_1 = require("@caddigital/sok-types/lib/lightAdmin");
const saveRequestSequence = ({ action$, fetchOpts, method, resolveRelativeUrl, filterActions, validatePayload }) => {
    return action$.pipe((0, operators_1.filter)(filterActions), (0, operators_1.mergeMap)((action) => {
        return validatePayload(action.payload)
            .mapLeft((e) => (0, rxjs_1.of)(Actions.saveLightAdminFailure((0, errorHandling_1.parseValidationError)(e))))
            .map((payload) => {
            return fetchOpts
                .ajax({
                method,
                headers: {
                    Authorization: fetchOpts.getToken(),
                    'Content-Type': 'application/json'
                },
                url: `${fetchOpts.baseUrl}${resolveRelativeUrl(action)}`,
                body: payload.body
            })
                .pipe((0, operators_1.mergeMap)(() => {
                return (0, rxjs_1.of)(...[
                    Actions.saveLightAdminSuccessful(),
                    MemberActions.toggleModal(),
                    MemberActions.UsergroupList.fetchRequest('PROJECT', payload.pathVariables.projectId)
                ]);
            }), (0, operators_1.catchError)((e) => {
                return (0, rxjs_1.of)(Actions.saveLightAdminFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)));
            }));
        }).value;
    }));
};
const create = (action$, store, fetchOpts) => {
    return saveRequestSequence({
        action$,
        fetchOpts,
        method: 'POST',
        resolveRelativeUrl: (action) => `api/project/${action.payload.pathVariables.projectId}/light-admin`,
        filterActions: (action) => action.type === ActionTypes.CREATE_LIGHT_ADMIN_REQUEST,
        validatePayload: (actionPayload) => lightAdmin_1.iCreateLightAdminRequest.decode(actionPayload)
    });
};
exports.create = create;
const edit = (action$, store, fetchOpts) => {
    return saveRequestSequence({
        action$,
        fetchOpts,
        method: 'PUT',
        resolveRelativeUrl: (action) => `api/project/${action.payload.pathVariables.projectId}/light-admin/${action.payload.pathVariables.id}`,
        filterActions: (action) => action.type === ActionTypes.EDIT_LIGHT_ADMIN_REQUEST,
        validatePayload: (actionPayload) => lightAdmin_1.iEditLightAdminRequest.decode(actionPayload)
    });
};
exports.edit = edit;
//# sourceMappingURL=lightAdmin.js.map